import { Serializable } from "../core";
import { Product } from "./product";

export class CartItem implements Serializable<CartItem> {
  productId!: string;
  attributeId!: string;
  count!: number;
  product!: Product;

  deserialize(json: any): CartItem {
    this.productId = json.productId;
    this.attributeId = json.attributeId;
    this.count = json.count;
    return this;
  }

  setProduct(product: Product): CartItem {
    this.product = product;
    return this;
  }
}
